import styled from '@emotion/styled';

import { SchoolJourneysDropdown } from '../school-journeys-dropdown/school-journeys-dropdown';

const Wrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-end;
`;

function SchoolJourneysHeader() {
  return (
    <Wrapper>
      <SchoolJourneysDropdown />
    </Wrapper>
  );
}

export { SchoolJourneysHeader };
